import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { MfaConfigMeta } from 'lumen/utils/constants/mfa-constants';
import type { MFAType } from 'password-form/utils/constant-values';

export default class MfaConfig extends Model {
  [Type] = 'mfa-config' as const;

  @attr declare enrolledAt: Date;
  @attr declare gipDisplayName: MFAType;
  @attr('json') declare meta: MfaConfigMeta;
}
